import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Hero from '../../components/pages/WealthAndSavingsDetails/Hero/Hero';
import Earn from '../../components/pages/WealthAndSavingsDetails/Earn/Earn';
import CoreParameters from '../../components/pages/WealthAndSavingsDetails/CoreParameters/CoreParameters';
import Savings from '../../components/pages/WealthAndSavingsDetails/Savings/Savings';
import AccountFeatures from '../../components/pages/WealthAndSavingsDetails/AccountFeatures/AccountFeatures';
import Growth from '../../components/pages/WealthAndSavingsDetails/Growth/Growth';
import { useWealthDetailContent } from '../../hooks/useWealthDetailContent';
import { getWealthProductBySlug } from '../../data/wealthProducts';

const WealthAndSavingsDetails = () => {
  const { slug } = useParams();
  const product = getWealthProductBySlug(slug);
  const { content, isLoading } = useWealthDetailContent(slug, product);

  if (!product) {
    return <Navigate to="/wealth-savings" replace />;
  }

  if (isLoading || !content) {
    return null;
  }

  return (
    <div>
      <Hero {...content.hero} />
      <Earn {...content.earn} />
      <CoreParameters {...content.coreParameters} />
      <Savings {...content.savings} />
      <AccountFeatures {...content.accountFeatures} />
      <Growth {...content.growth} />
    </div>
  );
};

export default WealthAndSavingsDetails;
